module.exports = __webpack_public_path__ + "media/directory/skill_icon_hover-746b3c58.svg";